import { render, staticRenderFns } from "./inside-event.vue?vue&type=template&id=c3508a36&scoped=true"
import script from "./inside-event.vue?vue&type=script&lang=js"
export * from "./inside-event.vue?vue&type=script&lang=js"
import style0 from "./inside-event.vue?vue&type=style&index=0&id=c3508a36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3508a36",
  null
  
)

export default component.exports